import { render, staticRenderFns } from "./NewPlacements.vue?vue&type=template&id=2f18d208&scoped=true&"
import script from "./NewPlacements.vue?vue&type=script&lang=ts&"
export * from "./NewPlacements.vue?vue&type=script&lang=ts&"
import style0 from "./NewPlacements.vue?vue&type=style&index=0&id=2f18d208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18d208",
  null
  
)

export default component.exports